import React, { useState, useContext } from 'react';
import { UserContext } from '../app/app';
import { capitalize } from 'lodash-es';
import { updateData } from '../firebase';
import './gift.scss';

const GiftShow = ({ gift, userId, uuid }) => {
  const { currentUser, users } = useContext(UserContext);
  const [currentGift, setCurrentGift] = useState(gift);

  const togglePurchased = () => {
    const giftClone = {
      ...currentGift,
      purchased: !currentGift.purchased,
      purchasedBy: !currentGift.purchased
        ? capitalize(currentUser.firstName)
        : null,
    };

    setCurrentGift(giftClone);
    updateData(`/users/${uuid}/gifts/${gift.uuid}`, giftClone);
  };

  const toggleApproved = () => {
    const giftClone = {
      ...currentGift,
      approved: !currentGift.approved,
    };

    setCurrentGift(giftClone);
    updateData(`/users/${uuid}/gifts/${gift.uuid}`, giftClone);
  };

  const toggleDelivered = () => {
    const giftClone = {
      ...currentGift,
      delivered: !currentGift.delivered,
    };

    setCurrentGift(giftClone);
    updateData(`/users/${uuid}/gifts/${gift.uuid}`, giftClone);
  };

  const showPurchasedBy = () => {
    if (!currentGift.purchased) return null;

    return <span> (by {currentGift.purchasedBy})</span>;
  };

  const findUserByUserId = (userId) =>
    Object.entries(users).filter(([, u]) => u.userId === userId);

  const isApprovedDisabled = (userId) =>
    !findUserByUserId(currentUser.uid)[0][1].children?.includes(uuid);

  const showApproved = () => {
    if (userId === currentUser.uid || currentUser.child || !users[uuid].child) {
      return null;
    }

    return (
      <label className="gift-approved">
        <input
          type="checkbox"
          value="approved"
          checked={currentGift.approved}
          onChange={toggleApproved}
          disabled={isApprovedDisabled(userId)}
        />
        <span>Approved</span>
      </label>
    );
  };

  const showDelivered = () => {
    if (userId === currentUser.uid || currentUser.child) {
      return null;
    }

    return (
      <label className="gift-delivered">
        <input
          type="checkbox"
          value="delivered"
          checked={currentGift.delivered}
          onChange={toggleDelivered}
        />
        <span>Delivered</span>
      </label>
    );
  };

  const showPurchased = () => {
    if (userId === currentUser.uid || currentUser.child) return null;

    return (
      <label className="gift-purchased">
        <input
          type="checkbox"
          value="purchased"
          checked={currentGift.purchased}
          onChange={togglePurchased}
        />
        <span>Purchased</span>
        {showPurchasedBy()}
      </label>
    );
  };

  return (
    <>
      <a className="gift-link" href={currentGift.url}>
        <div className="gift-wrapper">
          <img className="gift-image" src={currentGift.image} />
        </div>
        <div className="gift-details">
          <h1 className="gift-name">{currentGift.name}</h1>
          <p className="gift-description">{currentGift.details}</p>
          <span className="gift-price">{currentGift.price}</span>
        </div>
      </a>
      {showApproved()}
      {showPurchased()}
      {showDelivered()}
    </>
  );
};

export default GiftShow;
